export function booleanConvert<ReturnObjType = string>(test: boolean, trueReturn: ReturnObjType, falseReturn: ReturnObjType): ReturnObjType {
	return test ? trueReturn : falseReturn;
}
